import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { StreamAction } from '../stream.action';

type IDependencies = IClientApiDependencySegment;

export const updateStreamEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(StreamAction.update.started),
  mergeMap(({ params, resolve, reject }) => {
    const { streamId, name, markupProfileId } = params;

    return dependencies.api.updateStream({ streamId, name, markupProfileId }).pipe(
      mergeMap(() => {
        resolve?.();
        return [
          StreamAction.update.done({ params }),
          DetailsSidebarAction.toggleEdit(),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          StreamAction.update.failed({ params, error: null }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
